var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadOutlined(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3925_211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.99225 0 0 8.99225 0 20C0 31.0078 8.99225 40 20 40C31.0078 40 40 31.0078 40 20C40 8.99225 31.0078 0 20 0ZM20 38.7597C9.6124 38.7597 1.24031 30.3876 1.24031 20C1.24031 9.6124 9.6124 1.24031 20 1.24031C30.3876 1.24031 38.7597 9.6124 38.7597 20C38.7597 30.3876 30.3876 38.7597 20 38.7597Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.375 17.375C29 17.375 28.75 17.625 28.75 18V26C28.75 27 28 27.75 27 27.75H12.875C12 27.75 11.25 27 11.25 26.125V11.875C11.25 11 12 10.25 12.875 10.25H20.875C21.25 10.25 21.625 10 21.625 9.625C21.625 9.25 21.25 9 21 9H12.875C11.25 9 10 10.25 10 11.875V26C10 27.625 11.25 29 12.875 29H27C28.625 29 29.875 27.625 29.875 26.125V18C30 17.625 29.75 17.375 29.375 17.375Z",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.875 14.625C19.875 14.375 19.625 14 19.375 14C19 14 18.75 14.375 18.75 14.625V19.625C18.75 19.75 18.75 19.75 18.75 19.875L18.875 20L19 20.125C19.125 20.125 19.125 20.125 19.25 20.125H24.25C24.625 20.25 25 20 25 19.625C25 19.25 24.75 19 24.375 19H20.75L28.375 11.375C28.625 11.125 28.625 10.75 28.375 10.5C28.125 10.25 27.75 10.25 27.5 10.5L19.875 18.25V14.625Z",
    fill: "#808285"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3925_211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadOutlined);
export default __webpack_public_path__ + "static/media/download-outlined.abf52dc3f1354e58ee03373d46986711.svg";
export { ForwardRef as ReactComponent };